<template>
  <div
    class="flow-node-widget"
    :class="{ 'is-initial': isInitial, 'is-action-step': isActionStep, selected: isSelected }"
    @dblclick="handleEdit"
    @mousedown="onMouseDown"
  >
    <div class="node-header">
      <span class="node-id">步骤ID：{{ nodeId }}</span>
      <el-button
        type="text"
        size="mini"
        icon="el-icon-close"
        class="node-delete-btn"
        @click.stop="handleRemove"
      ></el-button>
    </div>
    <div class="node-title">{{ stepName || "未命名步骤" }}</div>
    <div class="node-tags">
      <el-tag v-if="problemStatus" size="mini" type="info">{{
        problemStatus | enumTransfer(enums.problemStatus)
      }}</el-tag>
    </div>
    <!-- 初始节点标记 -->
    <div v-if="isInitial" class="initial-marker">起始</div>
    <!-- 动作步骤标记 -->
    <div v-if="isActionStep" class="action-step-marker">动作</div>
    <!-- 端口 -->
    <div class="ports">
      <div class="in-port">
        <port-widget name="in" :node="node"></port-widget>
      </div>
      <div class="out-port">
        <port-widget name="out" :node="node"></port-widget>
      </div>
    </div>
  </div>
</template>

<script>
import { portWidget } from "vue-flowchart";
import { mapState } from "vuex";
export default {
  name: "FlowNodeWidget",
  components: {
    portWidget
  },
  props: {
    node: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default: ""
    },

    removeAction: {
      type: Function,
      default: () => {}
    },
    inPorts: {
      type: Array,
      default: () => ["in"]
    },
    outPorts: {
      type: Array,
      default: () => ["out"]
    }
  },
  inject: {
    getEngine: {
      from: "getEngine",
      default: () => () => null
    }
  },
  computed: {
    ...mapState("problemFlowConfig", ["enums"]),
    nodeId() {
      return this.node.id;
    },
    stepName() {
      return this.node.data?.stepName || this.name || "";
    },
    problemStatus() {
      return this.node.data?.problemStatus || null;
    },
    isInitial() {
      return this.node.data?.isInitial || false;
    },
    isActionStep() {
      return this.node.data?.actionStep === true;
    },
    engine() {
      return this.getEngine ? this.getEngine() : null;
    },
    isSelected() {
      return (
        this.engine &&
        this.engine.state &&
        this.engine.state.selectedNode &&
        this.engine.state.selectedNode.id === this.node.id
      );
    }
  },
  methods: {
    onMouseDown() {
      if (this.engine) {
        this.engine.setSelectedNode(this.node);
      }
    },
    handleEdit() {
      // 通过事件总线通知父组件
      this.$root.$emit("flow-node-edit", this.nodeId);
    },
    handleRemove() {
      // 通过事件总线通知父组件删除节点
      this.$root.$emit("flow-node-remove", this.nodeId);
    }
  }
};
</script>

<style lang="less" scoped>
.flow-node-widget {
  width: 200px;
  min-height: 120px;
  padding: 10px;
  background: #ffffff;
  border: 2px solid #dcdfe6;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  position: relative;

  &:hover {
    border-color: #409eff;
    box-shadow: 0 4px 8px rgba(64, 158, 255, 0.2);
  }

  &.selected {
    border-color: #409eff;
    box-shadow: 0 0 12px rgba(64, 158, 255, 0.4);
  }

  &.is-initial {
    border-color: #67c23a;
    background: #f0f9ff;
  }

  &.is-action-step {
    border-color: #e6a23c;
    background: #fef0e6;
  }

  .node-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 8px 0;
    font-weight: bold;

    .node-id {
      font-size: 12px;
      color: #409eff;
      font-weight: bold;
    }

    .node-delete-btn {
      padding: 0;
      font-size: 14px;
    }
  }

  .node-title {
    font-size: 14px;
    color: #303133;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .node-tags {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
  }

  .initial-marker {
    position: absolute;
    top: -8px;
    left: 10px;
    background: #67c23a;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 10px;
  }

  .action-step-marker {
    position: absolute;
    top: -8px;
    right: 10px;
    background: #e6a23c;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 10px;
  }

  .ports {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;

    .in-port {
      position: absolute;
      left: -8px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: all;
    }

    .out-port {
      position: absolute;
      right: -8px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: all;
    }
  }
}
</style>
